import React, { useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer';
import StatsSection from '../../components/StatsSection';
import ProcessSection from '../../components/ProcessSection';
import Newsletter from '../../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";

const FaqItem = ({ question, answer, defaultOpen = false }) => {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className={`accordion-button ${open ? '' : 'collapsed'}`}
          type="button"
          onClick={() => setOpen(prev => !prev)}
        >
          {question}
        </button>
      </h2>
      <div className={`accordion-collapse collapse ${open ? 'show' : ''}`}>
        <div className="accordion-body">{answer}</div>
      </div>
    </div>
  );
};

export default function LogoDigitizingForEmbroidery() {

    const logoEmbSteps = [
        { number: "01", title: "Submit Your Logo", description: "Send us your logo in any format such as JPG, PNG, PDF, or AI.", icon: "📤" },
        { number: "02", title: "Digitizing & Conversion", description: "Our experts convert your logo into a machine-ready embroidery file.", icon: "⚡" },
        { number: "03", title: "Quality Optimization", description: "We refine stitch paths, density, and detailing for precise results.", icon: "✓" },
        { number: "04", title: "File Delivery", description: "Receive your file in formats like DST, PES, JEF, and more.", icon: "🚀" }
    ];

    return (
        <>

            <Helmet>
                <title>Logo Digitizing for Embroidery in Los Angeles, CA | Grand Indigo Embroidery</title>
                <meta name="description" content="Convert your logo into embroidery files with expert logo digitizing services in Los Angeles, CA. High-quality results with fast delivery. Order today!" />
                <meta name="keywords" content="logo digitizing for embroidery, embroidery logo digitizing, convert logo to embroidery file, logo embroidery digitizing service, Los Angeles logo digitizing, embroidery digitizing near me" />
            </Helmet>

            <Header />

            <section className="breadcrumbsection">
                <div className='container'>
                    <h1>Logo Digitizing For Embroidery</h1>
                    <ul className='breadcrumblinks'>
                        <li><Link to="/">Home</Link></li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Services</li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Logo Digitizing For Embroidery</li>
                    </ul>
                </div>
            </section>


            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/logodigitizing1.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Precision in Every Stitch</span>
                                <h3 className="case-study-title">Professional Logo Digitizing for Embroidery in Los Angeles</h3>
                                <p className="case-study-description">
                                    At Grand Indigo Embroidery, we specialize in logo digitizing for embroidery in Los Angeles, California, helping businesses turn their brand identity into high-quality embroidered designs. Converting a logo into an embroidery-ready file requires precision, technical expertise, and a deep understanding of stitch behavior — and that’s exactly what our team delivers.
                                </p>
                                <p className="case-study-description">
                                    We carefully analyze your logo to determine the best stitch types, directions, and densities to ensure it translates perfectly onto fabric. Whether your logo is simple or highly detailed, our embroidery logo digitizing services ensure clean lines, smooth stitching, and professional results on garments, caps, uniforms, and promotional items. If you're searching for reliable logo digitizing services near you in Los Angeles, Grand Indigo Embroidery provides accuracy and consistency you can trust.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <StatsSection />

            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Optimized for Production</span>
                                <h3 className="case-study-title">High-Quality Logo Conversion for All Embroidery Applications</h3>
                                <p className="case-study-description">
                                    Our logo embroidery digitizing service is designed to meet the needs of businesses across various industries. From small chest logos to large designs for jackets and apparel, we create customized embroidery files that work seamlessly with all major embroidery machines.
                                </p>
                                <p className="case-study-description">
                                    We support all types of embroidery styles, including flat embroidery, 3D puff, and specialty applications. Every file is optimized for production, ensuring minimal thread breaks and maximum visual impact. Businesses in Los Angeles rely on us to convert logos to embroidery files that maintain brand consistency and quality. Whether you need to order logo digitizing online or require a trusted local provider, Grand Indigo Embroidery delivers fast, reliable, and professional results.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/logodigitizing2.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <ProcessSection steps={logoEmbSteps} />

            <section className="faqs-section">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <h2 className="section-title">Frequently Asked Questions</h2>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="accordion" id="faqAccordion">

                                <FaqItem
                                    defaultOpen={true}
                                    question="What is logo digitizing for embroidery?"
                                    answer="Logo digitizing is the process of converting a logo into a stitch file that embroidery machines can read and use to create embroidered designs."
                                />

                                <FaqItem
                                    question="Do you offer logo digitizing services in Los Angeles?"
                                    answer="Yes, Grand Indigo Embroidery provides professional logo digitizing for embroidery in Los Angeles, California, serving both local and online clients."
                                />

                                <FaqItem
                                    question="Can I convert my logo into an embroidery file online?"
                                    answer="Yes, you can easily submit your logo and convert it into an embroidery file online with our fast and reliable service."
                                />

                                <FaqItem
                                    question="How long does logo digitizing take?"
                                    answer="Most logo digitizing orders are completed within 12–24 hours depending on the design complexity."
                                />

                                <FaqItem
                                    question="What file formats do you provide for embroidery logos?"
                                    answer="We provide all major formats including DST, PES, JEF, and EXP to ensure compatibility with different embroidery machines."
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Newsletter />

            <Footer />
        </>
    )
}
